import { render, staticRenderFns } from "./NuevoPermiso.vue?vue&type=template&id=72d6e525"
import script from "./NuevoPermiso.vue?vue&type=script&lang=js"
export * from "./NuevoPermiso.vue?vue&type=script&lang=js"
import style0 from "./NuevoPermiso.vue?vue&type=style&index=0&id=72d6e525&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports